import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule, NavParams } from '@ionic/angular';
import { StylistChangePasswordFormComponent } from './stylist-change-password-form.component';
import { SalonMonsterLoadMaskModule } from '../smr-load-mask/smr-load-mask.module';

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, ReactiveFormsModule, SalonMonsterLoadMaskModule],
  providers: [NavParams],
  declarations: [StylistChangePasswordFormComponent]
})
export class StylistChangePasswordFormComponentModule {}
